import { render, staticRenderFns } from "./camp_publish_management.vue?vue&type=template&id=2d7739fc&scoped=true&"
import script from "./camp_publish_management.vue?vue&type=script&lang=js&"
export * from "./camp_publish_management.vue?vue&type=script&lang=js&"
import style0 from "./camp_publish_management.vue?vue&type=style&index=0&id=2d7739fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7739fc",
  null
  
)

export default component.exports